module.exports = __webpack_public_path__ + "static/img/basic02.b62c9d19.png";